// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"n4-z","categoryName":"o4-z","categoryImage":"p4-z","categoryContent":"q4-z","bottomAligned":"r4-z"};